import ExpensesScreen from './Expenses'

export default ExpensesScreen
